import { createSlice } from '@reduxjs/toolkit'
import { rolesApi } from '../api/rolesApi'
import type { UserRoles } from './types'

type RolesState = {
    roles: UserRoles
}

const initialState: RolesState = {
    roles: [],
}

const rolesSlice = createSlice({
    name: 'roles',
    initialState,
    reducers: {},
    extraReducers: (build) => {
        build.addMatcher(
            rolesApi.endpoints.getRoles.matchFulfilled,
            (state, { payload }) => {
                state.roles = payload
            }
        )
    },
})

export const rolesReducer = rolesSlice.reducer
